__turbopack_context__.v({
  "LanguageSwitcher": "style-module__Fy_6NW__LanguageSwitcher",
  "LanguageSwitcherOption": "style-module__Fy_6NW__LanguageSwitcherOption",
  "LanguageSwitcherSelect": "style-module__Fy_6NW__LanguageSwitcherSelect",
  "copyright": "style-module__Fy_6NW__copyright",
  "footer": "style-module__Fy_6NW__footer",
  "item": "style-module__Fy_6NW__item",
  "layout": "style-module__Fy_6NW__layout",
  "navigation": "style-module__Fy_6NW__navigation",
  "themeSwitcher": "style-module__Fy_6NW__themeSwitcher",
});
